import { kebabCaseAriaAttrs } from '../../../utils/formatAriaAttrKeys';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
const Styles = labelStyles('Menu', {
    root: {
        overflow: 'auto',
    },
});
export const Menu = (props) => {
    return (isolateComponent("ul", Object.assign({ css: Styles.root, role: props.role }, kebabCaseAriaAttrs(props)), props.children));
};
//# sourceMappingURL=Menu.js.map
// @zapier/design-system@6.28.0 (14d5b99c8)
